// removed by extract-text-webpack-plugin
module.exports = {"fileUploader":"DmcaCase_fileUploader_XMIny","explanation":"DmcaCase_explanation_1lSh3"};